import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthProvider } from "./contexts/authContext";
import "./styles.css";
import { AuditSessionProvider } from "./contexts/auditSessionContext";
import { SessionProvider } from "./contexts/sessionContext";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <SessionProvider>
          <AuditSessionProvider>
            <App />
          </AuditSessionProvider>
        </SessionProvider>
      </AuthProvider>
    </FluentProvider>
  );
});
